<template>
  <div class="flex-1 w-0 h-100 flex-column ptb-10 pr-20">
    <div class="flex content-top mb-10">
      <div class="flex-1 bg-ff h-100 flex align-center pl-10 mr-10">
        <div class="flex align-center mr-20 cursor" v-for="(item, index) in currentClassify.tab" :key="index"
          @click="changeStatus(index)">
          <div class="mr-5" :class="index === tabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
          <div class="font-bold" :class="index === tabIndex ? 'font-16-46b8b0' : 'font-16-30313a'">{{ item.name }}</div>
        </div>
      </div>
      <div class="flex  align-center ">
        <el-date-picker v-model="startTime" type="date" placeholder="开始时间" value-format="yyyy-MM-dd">
        </el-date-picker>
        <span class="font-12-b9b9b9"
          style="width: 24px;border: 1px solid #e2e2e2;height: 30px; line-height: 30px;">至</span>
        <el-date-picker v-model="endTime" type="date" placeholder="结束时间" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div class="flex align-center ml-10">
        <el-select class="flex-1" v-model="selectSupplier">
          <el-option v-for="(item, index) in supplier" :key="index" :label="item.name" :value="index"></el-option>
        </el-select>
      </div>
      <div class="flex ml-10">
        <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
          <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
          <el-input class="border-none" type="text" placeholder="材料名称/编码/规格/型号" v-model="keywords" clearable
            @keyup.enter.native="onSearch"></el-input>
        </div>
        <button class="btn-30-bg-46b8b0" @click="onSearch">搜索</button>
      </div>
    </div>
    <div class="mb-5 flex flex-wrap" v-if="currentClassify.btnList && tabIndex === 0">
      <div class="flex align-center mr-5 mb-5" :class="index === Index ? 'btn-24-bg-46b8b0' : 'btn-24-bg-ff'"
        @mouseenter="enter(index)" @mouseleave="leave(index)" v-for="(item, index) in currentClassify.btnList"
        :key="index" @click="btnClick(index)">
        <img :src="index === Index ? item.iconActive : item.icon" class=" mr-5"
          :class="item.iconStatus === 1 ? 'icon-12-14' : 'icon-14'" alt="">
        <div>{{ item.name }}</div>
      </div>
    </div>
    <div class="hr"></div>
    <div class="flex-1 h-0 flex-column">
      <div class="flex-1 h-0">
        <erp-table ref="erpTable" :table-footer="tableFooter1" @on-detail="onDetail" :table-data="tableData"
          :loading="loading" :column-data="columnData"></erp-table>
      </div>
      <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump">
      </Pagination>
    </div>
    <div class="filtrate">
      <el-dialog :visible.sync="showDialog" width="85%" :show-close="false">
        <div class="header">
          <!--<div class="font-bold " :class="founddetail.status === 1 ? 'font-22-30313a': 'font-22-ff5555'">{{founddetail.status === 1 ? '收款单据':'退款单据'}}</div>-->
          <div class="font-bold font-22-30313a">采购付款单</div>
          <i class="el-icon-close close1" @click="showDialog = false"></i>
        </div>
        <!--<div class="p-absolute" style="top: 0;left: 20px;"><img :src="founddetail.status ===1 ? '/static/images/weijizhang.png' : '/static/images/yijizhang.png'" style="width: 15px;height: auto" alt=""></div>-->
        <div class="p-absolute" style="top: 0;left: 20px;"><img
            :src="tabIndex === 0 ? '/static/images/weijizhang.png' : '/static/images/yijizhang.png'"
            style="width: 15px;height: auto" alt=""></div>
        <div class="bg-f3f4f7 plr-20 ptb-10">
          <div class=" flex text-left align-center">
            <div class="flex-1 mr-40">
              <div class="font-12-30313a mb-5"><span class="font-12-b9b9b9">单据编号：</span>{{ currentBill.number }}</div>
              <div class="font-12-30313a">
                <span class="font-12-b9b9b9">付款账号：</span>
                {{ currentBill.account }}
              </div>
            </div>
            <div class="flex-1 mr-40">
              <div class="font-12-30313a mb-5"><span class="font-12-b9b9b9">供应商：</span>{{ currentBill.businessName }}
              </div>
              <div class="font-12-30313a">
                <span class="font-12-b9b9b9">对方账号：</span>
                {{ currentBill.counterAccount }}
              </div>
            </div>
            <div class="flex-2">
              <div class="font-12-30313a flex mb-5 align-center">
                <div class="flex"><span class="font-12-b9b9b9">开单人员：</span>{{ currentBill.operatorName }}</div>
                <div class="flex flex-1 justify-end"><span class="font-12-b9b9b9">开单时间：</span>{{
                  Utils.formatTime(currentBill.createTime) }}</div>
              </div>
              <div class="font-12-30313a">
                <span class="font-12-b9b9b9">单据摘要：</span>
                {{ currentBill.description }}
              </div>
            </div>
          </div>
        </div>
        <div class="plr-20 ptb-10">
          <div style="height: 250px">
            <erp-table :table-data="currentBill.orderBillItemList" :column-data="dialogTableColumn"
              :table-footer="tableFooter"></erp-table>
          </div>
        </div>
        <div slot="footer">
          <div class="btn-30-bg-82b925-big mr-10" @click="onPrint">打印</div>
        </div>
      </el-dialog>
    </div>
    <el-dialog title="单据打印" :visible.sync="isReportShow" :fullscreen="true" class="flex-column" width="85%">
      <report :classify-id="9" :id="currentBill.id"></report>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import MoveHorizon from '@/components/MoveHorizon'
import MoveVertical from '@/components/MoveVertical'
import ErpTable from '@/components/ErpTable'
import XEUtils from 'xe-utils'
import Report from '@/components/Report'
XEUtils.mixin({
  toAccounting (cellValue) {
    return cellValue === 2 ? '已记账' : cellValue === 1 ? '未记账' : ''
  }
})
export default {
  name: 'MaterialOrder',
  components: { Pagination, MoveHorizon, ErpTable, MoveVertical, Report },
  props: ['currentClassify', 'supplier', 'optionList'],
  data () {
    return {
      btnPermissions: ['print'],
      keywords: '',
      page: 1,
      limit: 25,
      pageSize: 0, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 25, // 当前页条数
      total: 0, // 总条数
      billId: 0,
      startTime: '',
      endTime: '',
      selectSupplier: 0,
      tabIndex: 0,
      Index: -1,
      tableFooter1: [
        {
          columns: ['money'],
          type: 'sum',
          name: '合计'
        }
      ],
      columnData: [
        {
          type: 'selection',
          width: '50'
        }, {
          field: 'operate',
          title: '操作',
          width: '80',
          isDefine: true,
          child: [{
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '详情',
            methodName: 'on-detail',
            type: 'btn'
          }]
        }, {
          field: 'status',
          title: '单据状态',
          width: '80',
          formatter: 'toAccounting'
        }, {
          field: 'number',
          title: '单据号',
          width: '150'
        }, {
          field: 'createTime',
          title: '编制日期',
          width: '100',
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'businessName',
          title: '供应商',
          width: '210'
        }, {
          field: 'account',
          title: '账户',
          width: '130'
        }, {
          field: 'money',
          title: '金额',
          width: '100'
        }, {
          field: 'description',
          title: '摘要',
          minWidth: '200'
        }
      ],
      loading: false,
      tableData: [1, 2],
      isReportShow: false,
      showDialog: false,
      dialogTableColumn: [
        {
          type: 'index',
          title: '序号',
          width: '60'
        }, {
          field: 'name',
          title: '单据名称',
          width: '110'
        }, {
          field: 'orderCode',
          title: '材料单据号',
          width: '150'
        }, {
          field: 'planBill',
          title: '应付金额',
          width: '100'
        }, {
          field: 'realBill',
          title: '实付金额',
          width: '100'
        }, {
          field: 'description',
          title: '备注',
          width: ''
        }
      ],
      tableFooter: [
        {
          columns: ['planBill', 'realBill'],
          type: 'sum',
          name: '合计'
        }
      ],
      dialogTableData: [],
      option: 0,
      currentBill: {}
    }
  },
  created () {
    this.getData()
  },
  mounted () { },
  methods: {
    onPrint () {
      // this.orderId = this.detailItem.id
      this.$nextTick(() => {
        this.isReportShow = true
      })
    },
    onDetail (row) {
      this.currentBill = row
      this.showDialog = true
    },
    getData () {
      let params = {
        page: this.page,
        limit: this.limit,
        companyId: this.$store.state.companyId,
        businessId: this.supplier[this.selectSupplier].id,
        keywords: this.keywords,
        startTime: this.startTime,
        endTime: this.endTime,
        status: this.tabIndex + 1,
        type: 1
      }
      this.loading = true
      this.axios.post('orderBill/queryForPage', params).then(res => {
        this.loading = false
        if (res.data.success) {
          this.tableData = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg,
            offset: 400
          })
        }
      })
    },
    onSearch () {
      this.page = 1
      this.$refs.erpTable.setAllSelection(false)
      this.getData()
    },
    changeStatus (index) {
      this.tabIndex = index
      this.page = 1
      this.getData()
    },
    btnClick (index) {
      let dataArr = this.$refs.erpTable.getSelectEvent()
      if (!dataArr.length) {
        this.$message({
          message: `请先选择要${index === 0 ? '记账' : '删除'}的单据`,
          type: 'warning'
        })
        return
      }
      let that = this
      this.$confirm(`确定要将选中数据${index === 0 ? '记账' : '删除'}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let idArr = []
        for (let i = 0; i < dataArr.length; i++) {
          idArr.push(dataArr[i].id)
        }
        let url = ''
        let params = null
        switch (index) {
          case 0:
            url = 'orderBill/accounting'
            params = { ids: idArr.join(',') }
            break
          case 1:
            url = 'orderBill/deleteByIds'
            params = that.qs.stringify({ ids: idArr.join(',') })
            break
        }
        that.axios.post(url, params).then(res => {
          if (res.data.success) {
            that.$message.success(`${index === 0 ? '记账' : '删除'}成功！`)
            that.getData()
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg,
              offset: 400
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getData()
    },
    enter (a) {
      this.Index = a
    },
    leave () {
      this.Index = -1
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.$refs.erpTable.setAllSelection(false)
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filtrate /deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.filtrate /deep/ .el-dialog {
  border-radius: 6px;
  margin: 0 !important;
  max-height: 100%;
  height: auto;
}

.filtrate /deep/ .el-dialog__header {
  display: none;
}

.filtrate /deep/ .el-dialog__body {
  padding: 0;
  display: flex;
  flex-direction: column;
}

.header {
  border-bottom: 1px solid #e2e2e2;
  padding: 14px;
  position: relative;
}

.close1 {
  color: #30313a;
  font-size: 22px;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 10px;
  background: #ffffff;
}

.decoration-line {
  width: 4px;
  height: 16px;
  background-color: #46b8b0;
  border-radius: 4px;
}

.decoration-line-hui {
  width: 4px;
  height: 16px;
  background-color: #e2e2e2;
  border-radius: 4px;
}

.content-top {
  height: 30px;

  .tab-item {
    font-size: 16px;
    color: #272727;
    display: flex;
    align-items: center;
    line-height: 30px;
    margin-right: 15px;
    cursor: pointer;

    span {
      height: 16px;
    }

    &.active {
      color: #46b8b0;
    }
  }
}

.el-icon-zoom-in {
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 14px;
  color: #30313a;
}

.font-13-46b8b0 {
  font-size: 13px;
  color: #46b8b0;
}

.el-card {
  height: 90px;
  border: 1px solid #e2e2e2;
  cursor: pointer;
}

.info-item {
  width: 198px;
  border-bottom: 1px solid #e2e2e2;
  display: flex;
  align-items: center;
  margin-top: 10px;
  font-size: 12px;
  color: #30313a;
  margin-right: 30px;
  line-height: 20px;
  height: 20px;
}

.search {
  overflow: hidden;
}

.search /deep/.el-input__inner {
  padding-left: 0;
  border: none;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/financeManage/comp/MaterialOrder.vue